module.exports = __webpack_public_path__ + "media/images/icon-thema-3x-b900925c7f8eb951a4be2a2506dd0027.png";